import { CardsContainer, Card, Value, Title } from './ReportCard.styles';

interface CardData {
  color: string;
  title: string;
  value: string | number;
}

interface ReportCardProps {
  data: CardData[];
}

const ReportCard: React.FC<ReportCardProps> = ({ data }) => {
  return (
    <CardsContainer>
      {data.map((item, index) => (
        <Card key={index} color={item.color}>
          <Title>{item.title}</Title>
          <Value>{item.value}</Value>
        </Card>
      ))}
    </CardsContainer>
  );
};

export default ReportCard;
